export const TabKeys = {
  Gallery: 'gallery',
  Photos: 'photos',
  Floorplans: 'floorplans',
  VirtualTour: 'vtour',
  Video: 'video',
} as const;

export type TabKeys = (typeof TabKeys)[keyof typeof TabKeys];
